import AddressEditorContainer from './containers/AddressEditorContainer'

export default AddressEditorContainer
